/**
 * TA 的朋友（新版）的两条读：GET /pets/{pet_id}/friends（PetFriendPage）、GET /pets/{pet_id}/friends/{friend_id}（PetFriendDetail）。
 * 纯读，只给这只宠物当前家庭的家人；不是家人、没有这位朋友（以及看不到的几种情况）后端一律同一个 404。
 *
 * 为什么先放在模块里、不进 shared/services 的 SocialService：shared 这一层要报主窗口批了才动。
 * 形状照 SocialService 的写法（petId 在前、signal 在后），批下后把这两个方法搬进 SocialService、
 * live / 演示两套搬进 social 模块的 services，页面只改取服务的那一行（见 ./usePetFriends）。
 *
 * 演示世界没有真实的相遇（同旧的 social.friends）：演示服务报“还没开放”，页面给一句说明，不编朋友。
 */
import type { PetFriendDetail, PetFriendPage } from "@/shared/contracts";
import type { ApiClient } from "@/shared/api/client";
import { ApiError } from "@/shared/api/errors";

export interface PetFriendsReader {
  /** TA 的朋友，最近往来的在前，最多 200 位（truncated 表示只列了这些）。 */
  friends(petId: string, signal?: AbortSignal): Promise<PetFriendPage>;
  /** 一位朋友的详情：相遇、共同经历、实际交流三段；每段为 null 表示不知道，为空表示没有。 */
  friend(petId: string, friendId: string, signal?: AbortSignal): Promise<PetFriendDetail>;
}

export function livePetFriendsReader(api: ApiClient): PetFriendsReader {
  return {
    friends: (petId, signal) => api.request<PetFriendPage>(`/pets/${encodeURIComponent(petId)}/friends`, { signal }),
    friend: (petId, friendId, signal) => api.request<PetFriendDetail>(`/pets/${encodeURIComponent(petId)}/friends/${encodeURIComponent(friendId)}`, { signal }),
  };
}

export function demoPetFriendsReader(): PetFriendsReader {
  return {
    friends: async () => {
      throw ApiError.capability("social.pet_friends", "演示模式没有朋友记录。");
    },
    friend: async () => {
      throw ApiError.capability("social.pet_friends", "演示模式没有朋友记录。");
    },
  };
}
